<!--
  --
  -- URL 未定義エラーページ
  --
  -->
<template>
  <c-error-page
    code="404"
    caption="THIS PAGE DOESN'T EXIST!"
  />
</template>

<script>
import page from '@/mixins/page'
import CErrorPage from './CErrorPage'

export default {
  name: 'NotFound',
  mixins: [
    page('Not Found')
  ],
  components: {
    CErrorPage
  }
}
</script>
